import React, { forwardRef, memo } from "react";

import ImageUploadZone, { ImageUploadZoneHandle, InitialAttachment } from "./ImageUploadZone";
import { ImageUploadFieldConfig } from "./ImageUploadFields";

interface FieldImageUploadPropType {
    config: ImageUploadFieldConfig;
    uniqueDataFieldId: any;
    visible: boolean;
    disabled?: boolean;
    initialAttachments?: InitialAttachment[];
    attachmentsEquipmentId?: any;
    attachmentsRefreshKey?: any;
    uniqueInspectionTaskId?: any;
    equipmentId?: any;
    onFilesChange?: (tempStorageDirectory: string, fileCount: number, unsavedFileCount?: number) => void;
    onUploadingChange?: (isUploading: boolean) => void;
    onBusyChange?: (isBusy: boolean) => void;
}

const FieldImageUpload = forwardRef<ImageUploadZoneHandle, FieldImageUploadPropType>((props, ref) => {

    const {
        config,
        uniqueDataFieldId,
        visible,
        disabled = false,
        initialAttachments,
        attachmentsEquipmentId,
        attachmentsRefreshKey,
        uniqueInspectionTaskId,
        equipmentId,
        onFilesChange = () => { },
        onUploadingChange = () => { },
        onBusyChange = () => { },
    } = props;

    // Hidden with CSS, not unmounted: unmounting destroys FilePond and the files it holds.
    // Deliberately NOT display:none - FilePond measures its container to lay items out, and a
    // display:none container has zero size, so images seeded while hidden stayed collapsed and
    // invisible even once the field gained text. Instead the zone keeps its normal size and is
    // collapsed by the outer wrapper, so measurements taken while hidden are still correct.
    return (
        <div
            style={visible ? undefined : { height: 0, overflow: "hidden", opacity: 0, pointerEvents: "none" }}
            aria-hidden={!visible}
        >
            <ImageUploadZone
                ref={ref}
                fieldKey={`${config.key}-${uniqueDataFieldId}`}
                labelIdle={config.labelIdle}
                maxFiles={config.maxFiles}
                disabled={disabled}
                initialAttachments={initialAttachments}
                attachmentsEquipmentId={attachmentsEquipmentId}
                attachmentsRefreshKey={attachmentsRefreshKey}
                uniqueInspectionTaskId={uniqueInspectionTaskId}
                equipmentId={equipmentId}
                onFilesChange={onFilesChange}
                onUploadingChange={onUploadingChange}
                onBusyChange={onBusyChange}
            />
        </div>
    );
});

export default memo(FieldImageUpload);
